module.exports = __webpack_public_path__ + "static/media/4.94c9a5cc.jpg";